module.exports = __webpack_public_path__ + "static/media/favorite-fill.e7dacd83.svg";